import { useEffect } from 'react';

import { ModalCloseButton } from './InfoModals';
import { getRuntimeConfigValue } from '../runtimeConfig';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TERMS_OF_SERVICE_URL = getRuntimeConfigValue('termsOfServiceUrl');
const PRIVACY_POLICY_URL = getRuntimeConfigValue('privacyPolicyUrl');

function TermsModal({ isOpen, onClose }: TermsModalProps) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          <h2 id="terms-modal-title">Terms of Service and Privacy Policy</h2>
          <ModalCloseButton onClose={onClose} />
        </div>

        <div className="modal-body">
          <p>
            Read the full{' '}
            <a href={TERMS_OF_SERVICE_URL} target="_blank" rel="noopener noreferrer">Terms of Service</a>
            {' '}and{' '}
            <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            {' '}before starting a scan.
          </p>

          <h3>AI processing</h3>
          <p>
            Your uploaded code is processed by third-party AI providers. By starting a scan, you agree to the Claude and ChatGPT terms and privacy policies for any AI processing involved. Claude Fable 5.1 may retain data for monitoring safe and compliant use of AI; Anthropic does not offer zero data retention.{' '}
            <a
              href="https://support.claude.com/en/articles/15425996-data-retention-practices-for-mythos-class-models"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
